// src/redux/slices/authSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiBaseUrl, getSettings } from "../../Utils/Constants";
import { toast } from "react-toastify";

export const hitGetSettingsApi = createAsyncThunk("hitGetSettingsApi", async () => {
  try {
    const config = {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        //Authorization: `${localStorage.getItem("clientToken")}`,
      },
    };
    const url = ApiBaseUrl + getSettings;
    const response = await axios.get(url, config);
    return response.data;
  } catch (error) {
    toast.error(error.response.data.message);
    throw error.response.data;
  }
});

const GetSettingsSlice = createSlice({
  name: "getSettingsReducer",
  initialState: {
    isLoading: false,
    data: null,
  },
  reducers: {
    clearhitGetSettingsData: (state) => {
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(hitGetSettingsApi.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(hitGetSettingsApi.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(hitGetSettingsApi.rejected, (state) => {
        state.isError = false;
      });
  },
});

export const { clearhitGetSettingsData } = GetSettingsSlice.actions;
export default GetSettingsSlice.reducer;
